/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Set_UndoneInputs */

const en_us2_workout_set_undone = /** @type {(inputs: Workout_Set_UndoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set undone`)
};

const pt_br2_workout_set_undone = /** @type {(inputs: Workout_Set_UndoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série desfeita`)
};

const es_419_workout_set_undone = /** @type {(inputs: Workout_Set_UndoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie deshecha`)
};

const pt_pt2_workout_set_undone = /** @type {(inputs: Workout_Set_UndoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série anulada`)
};

const fr_fr2_workout_set_undone = /** @type {(inputs: Workout_Set_UndoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série annulée`)
};

const de_de2_workout_set_undone = /** @type {(inputs: Workout_Set_UndoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satz rückgängig gemacht`)
};

const it_it2_workout_set_undone = /** @type {(inputs: Workout_Set_UndoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie annullata`)
};

/**
* | output |
* | --- |
* | "Set undone" |
*
* @param {Workout_Set_UndoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_set_undone = /** @type {((inputs?: Workout_Set_UndoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Set_UndoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_set_undone(inputs)
	if (locale === "es-419") return es_419_workout_set_undone(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_set_undone(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_set_undone(inputs)
	if (locale === "de-DE") return de_de2_workout_set_undone(inputs)
	if (locale === "it-IT") return it_it2_workout_set_undone(inputs)
	return en_us2_workout_set_undone(inputs)
});
export { workout_set_undone as "workout.set_undone" }